import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  product: {
    defaultMessage: 'Product',
    id: 'OT9ERX',
    description: 'Product column header',
  },
  location: {
    defaultMessage: 'Location',
    id: 'v4UD0E',
    description: 'Location column header',
  },
  lotId: {
    defaultMessage: 'Lot ID',
    id: 'lQBbS6',
    description: 'Lot ID column header',
  },
  expirationDate: {
    defaultMessage: 'Exp. Date',
    id: 'EuHfdD',
    description: 'Expiration Date column header',
  },
  productSku: {
    defaultMessage: 'SKU: {sku}',
    id: 'DfmwVQ',
    description: 'Product SKU',
  },
});
